import React from 'react';
import PageBody from 'Common/Custom/PageBody';
import { HeadingOne } from "Common/Custom/HeadingOne";
import AddItemBtn from 'Common/Custom/AddItemBtn';
import BookingTypeListTable from './Components/BookingTypeListTable';

const BookingTypeList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Booking Type List</HeadingOne>
                    <AddItemBtn url="add-booking-type" title="Add Booking Type" />
                </>
            }
        >
            <div className="col-12">
                <BookingTypeListTable />
            </div>
        </PageBody>
    );
};

export default BookingTypeList;